import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from '@/store';
import vuetify from './plugins/vuetify';
import VModal from 'vue-js-modal';
// VueTouchKeyboardをカスタマイズしているため、ビルド済を以下より取得。
import VueTouchKeyboard from './common/vue-touch-keyboard';
import StyleTouchKeyBoard from './common/vue-touch-keyboard.css';
import './common/vue-good-table.css';
import VueGoodTable  from './common/vue-good-table';
import './registerServiceWorker';

Vue.use(VModal)
Vue.use(VueTouchKeyboard)
Vue.use(VueGoodTable)
Vue.config.productionTip = false

var vm = new Vue({
  vuetify,
  router,
  VueTouchKeyboard,
  VueGoodTable,
  StyleTouchKeyBoard,
  render: h => h(App),
  store
}).$mount('#app')

window.vm = vm